import { createSvgComponent } from "../../icon/createSvgComponent";
import ShoppingCartMenu from "@core/icon/assets/shopping-cart-menu.svg";
export default createSvgComponent(ShoppingCartMenu);